import { useMemo } from 'react';

import { ErrorDialogContext } from '../../../../../../components/ErrorDialog';
import { Routes } from '../../../../../../constants/Routes';
import { useContext } from '../../../../../../hooks/useContext';
import { useReservationId } from '../../../../../../hooks/useReservationId';
import { useTransaction } from '../../../../../../hooks/useTransaction';
import { SessionStore } from '../../../../../../stores/SessionStore';
import { Payjp3dSecureStore } from '../../../../store/Payjp3dSecureStore';
import { GuestWaitingListStore } from '../stores/GuestWaitingListStore';

export const useActions = (session: SessionStore) => {
  const { push, encode } = useReservationId();
  const { setError } = useContext(ErrorDialogContext);

  const store = useMemo(() => {
    const res = new GuestWaitingListStore();
    res.userId = session.user?.userId;
    const search = new URL(window.location.href).searchParams;
    res.clinic = search.get('clinic') || '';
    res.department = search.get('department') || '';
    res.treatmentKind = search.get('treatmentKind') || '';
    res.start = search.get('start') || '';
    res.end = search.get('end') || '';
    return res;
  }, [session.user]);

  const handleError = (message: string) => {
    setError({
      header: '予約に失敗しました',
      message,
      onOk: () => {
        session.logout('/');
        setError();
      },
    });
  };

  const [load, loadStatus] = useTransaction(
    async () => {
      await session.fetchUserEntity();
      store.setNewComer(!session.user?.userEntity?.name);

      if (!store.newComer) {
        await doFix();
      }
    },
    e => {
      handleError(e.message);
    },
  );

  const [doFix, fixStatus] = useTransaction(
    async () => {
      await store.fix();
      if (store.card?.id) {
        const fullPath = `${window.location.origin}${Routes.Paths.Payjp3dSecureFinish}?waitingId=${encode(store.id)}`;
        const payjp3dSecureStore = new Payjp3dSecureStore(store.card.id, fullPath);
        await payjp3dSecureStore.redirect3dSecure();
      } else {
        push(Routes.Paths.WaitingSuccess, store.id);
      }
    },
    e => {
      handleError(e.message);
    },
  );

  return {
    doFix,
    fixStatus,
    load,
    loadStatus,
    store,
  };
};
